import { createFileRoute, redirect } from '@tanstack/react-router';

/** Home is Conversations, opened on Needs you. */
export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/conversations', replace: true });
  },
});
